(ns manatee.session.app-db
  (:require [#?(:clj clj-time.core :cljs cljs-time.core) :as t]
            [manatee.app-db :refer [ping-interval-seconds xhr-retry-limit]]))

(def session-root [:session])
(def activity-path (conj session-root :activity))
(def events-failure-count-path (conj session-root :events-failure-count))
(def last-events-time-path (conj session-root :last-events-time))

(defn set-activity
  [db timesheet]
  (assoc-in db activity-path timesheet))

(defn get-activity
  [db]
  (get-in db activity-path))

(defn get-session
  [db]
  (get db (first session-root)))

(defn post-events-failure
  [db]
  (update-in db events-failure-count-path (fnil inc 0)))

(defn post-events-failure-count
  [db]
  (get-in db events-failure-count-path))

(defn retry-post-events?
  [db]
  (> (xhr-retry-limit db) (get-in db events-failure-count-path)))

(defn reset-events-retries
  [db]
  (update-in db session-root dissoc :events-failure-count))

(defn set-last-events-time
  [db]
  (assoc-in db last-events-time-path (t/now)))

(defn clear-last-events-time
  [db]
  (assoc-in db last-events-time-path nil))

(defn ping-interval-has-passed-since-last-events?
  [db]
  (if-let [last-events-time (get-in db last-events-time-path)]
    (-> last-events-time
        (t/interval (t/now))
        t/in-seconds
        (>= (ping-interval-seconds db)))
    true))
